import { createFileRoute, type SearchSchemaInput } from "@tanstack/react-router"
import { z } from "zod"

const complianceSchema = z.object({
  facilities: z.array(z.coerce.number()).optional().catch(undefined),
})

export const Route = createFileRoute("/_app/reports/compliance/")({
  validateSearch: (search: SearchSchemaInput) => complianceSchema.parse(search),
})
